const ukrainianLanguage = {
    navigationMenu: {
        firstLink: "Інтер'єр",
        secondLink: "Екстер'єр",
        thirdLink: "Контакти",
        fourthLink: "English",
        phoneCall: "Зателефонуйте нам",
        phoneNumber: "+38 096 472 94 50"
    },
    homeSection: {
        firstTextBlock: "Вітаємо\n" +
            "у гостьовому \n" +
            "будиночку \n" +
            "SCANDINAVIA",
        secondTextBlock: "Запрошуємо тих, хто мріє про \n" +
            "затишну атмосферу сімейного \n" +
            "відпочинку, провести час у \n" +
            "невеликому фінському \n" +
            "будиночку біля лісу."
    },
    transitionSection: {
        header: "Náttúran",
        subheader: "Природа",
        quote: "\"Іноді один день проведений у інших \n" +
            "місцях дає нам значно більше ніж 10 \n" +
            "років життя вдома.\"",
        author: "Анатоль Франс",
        whoIsAuthor: "(французький письменник)"
    },
    exteriorSection: {
        summer: {
            header: "Sommar",
            subheader: "літо"
        },
        autumn: {
            header: "Höst",
            subheader: "осінь"
        },
        winter: {
            header: "Vinter",
            subheader: "зима"
        },
        spring: {
            header: "Vår",
            subheader: "весна"
        }
    },
    interiorSection: {
        header: "Bekvämlighet",
        subheader: "Комфорт",
        firstTextBlock: "Відпочиваючи у гостьовому будиночку \n" +
            "SCANDINAVIA, ви зможете насолодитись \n" +
            "єднанням із природою та провести час у \n" +
            "приємній обстановці. Стильний дизайн \n" +
            "створює особливий затишок у помешканні.\n" +
            "Це чудове рішення для незабутнього \n" +
            "відпочинку разом з близькими людьми.\n",
        secondTextBlock: [
            "- цифрове телебачення",
            "- комплект посуду",
            "- три подвійних спальних місця, для 6 осіб",
            "- тераса з панорамними вікнами",
            "- постіль та рушники",
            "- кухня з електроплитою",
            "- холодильник"
        ]
    },
    contactsSection: {
        title: "SCANDINAVIA",
        subtitle: "guest house",
        infoBlock: "Залишились питання?\n" +
            "Ви можете зв'язатися з нами \n" +
            "одним з наступних способів",
        socialNetworks: {
            header: "Стежте за нами",
            facebook: "Facebook",
            instagram: "Instagram",
            youtube: "Youtube"
        },
        contacts: {
            header: "Контакти",
            address: "м. Рівне 33017",
            phone: "+38 096 472 9450",
            email: "greentourisminua@gmail.com"
        },
        copyright: "Copyright 2021. Усі права захищені.",
        madeBy: "Розроблено Anton Novak у 2021 році."
    },
    galleryPage: {
        winter: {
            text: "Зима - це час теплих речей, гарячого чаю\n" +
                "та зустрічей з близькими. Пориньте \n" +
                "у атмосферу затишку та сімейного \n" +
                "відпочинку. Проведіть зимові свята у \n" +
                "гостьовому будиночку SCANDINAVIA. \n" +
                "Відчуйте затишок та натуральне тепло \n" +
                "від потріскуючих дров.",
            author: "Наша команда"
        },
        summer: {
            text: "\"Відпочинок - не бездіяльність, а іноді \n" +
                "лежати на траві під деревами в літній день, \n" +
                "слухаючи шум води або спостерігаючи, як \n" +
                "хмари пливуть по небу, це аж ніяк не марна \n" +
                "трата часу.\"\n",
            author: "Джон Лаббок"
        },
        autumn: {
            text: "\"... Добре, що є осінь, вона ніжно й акуратно\n" +
                "готує нас до холодів. Улюблена осінь. Час \n" +
                "роздумів, рук в кишенях, глінтвейну \n" +
                "вечорами й приємної меланхолії ...\"\n",
            author: "Єльчин Сафарлі"
        },
        spring: {
            text: "\"Весна - це завжди романтика. Це нові \n" +
                "бажання і якийсь піднесений настрій. Це \n" +
                "не просто якесь число на календарі, а стан \n" +
                "душі. Весна розвивається з такою ж \n" +
                "швидкістю, що і наша природа.\"\n",
            author: "М. Мастроянні"
        }
    }
};

export default ukrainianLanguage;